import apiClient from "../utils/apiClient";

export const getAllServices = async ({ isActive, search, page, pageSize } = {}) => {
  const params = new URLSearchParams();

  if (isActive !== undefined) params.append('isActive', isActive);
  if (search) params.append('search', search);
  if (page) params.append('page', page);
  if (pageSize) params.append('pageSize', pageSize);

  const response = await apiClient.get("/services/getallservices", { params });

  return response.data;
};
